const interfaceIds = {
  ISoundEditionV2: "0x7888cfe1",
  ISuperMinter: "0x1459ad68"
};

export { interfaceIds };
